// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { RemoteUrlValidationResult, RepositoryAuthType, TID, URemoteRepositoryAuth } from "./TypeDefinitions.ts"

export interface InitProjectApi {
  setProjectName(taskId: TID, name: string, createEmptyProject: boolean | null): Promise<void>

  setRepositoryAccess(taskId: TID, authType: RepositoryAuthType): Promise<void>

  setRepositoryAuth(taskId: TID, auth: URemoteRepositoryAuth): Promise<void>

  setRepositoryUrl(taskId: TID, url: string): Promise<void>

  showPersonalTokenHelp(taskId: TID): Promise<void>

  supportedAuthTypes(url: string): Promise<RepositoryAuthType[]>

  validateRemoteUrl(url: string): Promise<RemoteUrlValidationResult>
}

export class InitProjectApiClient implements InitProjectApi {
  constructor(private service: ApiService) {}

  async setProjectName(taskId: TID, name: string, createEmptyProject: boolean | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitProjectApi/setProjectName", {
      taskId: taskId,
      name: name,
      createEmptyProject: createEmptyProject,
    }))
  }

  async setRepositoryAccess(taskId: TID, authType: RepositoryAuthType): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitProjectApi/setRepositoryAccess", {
      taskId: taskId,
      authType: authType,
    }))
  }

  async setRepositoryAuth(taskId: TID, auth: URemoteRepositoryAuth): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitProjectApi/setRepositoryAuth", {
      taskId: taskId,
      auth: auth,
    }))
  }

  async setRepositoryUrl(taskId: TID, url: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitProjectApi/setRepositoryUrl", {
      taskId: taskId,
      url: url,
    }))
  }

  async showPersonalTokenHelp(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitProjectApi/showPersonalTokenHelp", {
      taskId: taskId,
    }))
  }

  async supportedAuthTypes(url: string): Promise<RepositoryAuthType[]> {
    return getResult(await this.service.rpc<RepositoryAuthType[], never>("InitProjectApi/supportedAuthTypes", {
      url: url,
    }))
  }

  async validateRemoteUrl(url: string): Promise<RemoteUrlValidationResult> {
    return getResult(await this.service.rpc<RemoteUrlValidationResult, never>("InitProjectApi/validateRemoteUrl", {
      url: url,
    }))
  }

}

